import { LOGIN } from 'constants/api-paths'
import request from './request'

export const requestLogin = async (params) => {
  const response = await request.post(LOGIN, params)
    .then((resp) => resp)
    .catch((error) => error)

  return response
}
